import React from 'react';

const AdminButton = ({
    children,
    variant = 'primary',
    size = 'md',
    type = 'button',
    onClick,
    disabled = false,
    className = '',
    fullWidth = false,
    ...props
}) => {
    // Base classes
    const baseClasses = 'inline-flex items-center justify-center font-medium rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';
    
    // Size classes
    const sizeClasses = {
        sm: 'px-3 py-1.5 text-xs',
        md: 'px-4 py-2 text-sm',
        lg: 'px-6 py-3 text-base',
    };

    // Variant classes
    const variantClasses = {
        primary: 'border border-transparent text-white bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 shadow-sm',
        secondary: 'border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 focus:ring-blue-500 shadow-sm',
        danger: 'border border-transparent text-white bg-red-600 hover:bg-red-700 focus:ring-red-500 shadow-sm',
        outline: 'border border-gray-300 text-gray-600 bg-transparent hover:bg-gray-50 focus:ring-gray-500',
        ghost: 'border border-transparent text-gray-600 bg-transparent hover:bg-gray-100 focus:ring-gray-500',
        pink: 'border border-transparent text-white bg-pink-600 hover:bg-pink-700 focus:ring-pink-500 shadow-sm'
    };

    // State classes
    const stateClasses = disabled 
        ? 'opacity-50 cursor-not-allowed bg-gray-400 border-transparent hover:bg-gray-400 text-white' 
        : variantClasses[variant] || variantClasses.primary;

    const widthClass = fullWidth ? 'w-full' : '';

    return (
        <button
            type={type}
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            className={`${baseClasses} ${sizeClasses[size] || sizeClasses.md} ${stateClasses} ${widthClass} ${className}`}
            {...props}
        >
            {children}
        </button>
    );
};

export default AdminButton;
